<div class="toolbar-break"></div>
<div class="container my-5">
  <!-- DESKTOP -->
  <div class="d-none d-lg-block">
    <div class="row">
      <div class="col-12 col-lg-6">
        @if ((product$ | async) === undefined) {
          <ngx-skeleton-loader count="1" [theme]="{ width: '400px', height: '400px' }">
          </ngx-skeleton-loader>
        }
        @if (product$ | async; as product) {
          <img class="product-image" [src]="product.variants[variantIndex].image.url" [alt]="product.variants[variantIndex].image.altText">
          <div class="mt-5">
            <h3>Description</h3>
            <span [innerHtml]="product.descriptionHtml"></span>
          </div>
        }
      </div>
      <div class="col-12 col-lg-6">
        <div class="d-flex justify-content-between align-items-end mb-3">
          <div class="product-title">
            @if (product$ | async; as product) {
              <h1 class="mb-0">{{product.title}}</h1>
            } @else {
              <div class="d-flex d-lg-none">
                <ngx-skeleton-loader count="1"
                  [theme]="{ width: '100%', height: '36px' }">
                </ngx-skeleton-loader>
              </div>
              <div class="d-none d-lg-block">
                <ngx-skeleton-loader count="2"
                  [theme]="{ width: '100%', height: '50px' }">
                </ngx-skeleton-loader>
              </div>
            }
          </div>
          <div class="text-end">
            @if (product$ | async; as product) {
              @if (product.variants[variantIndex]) {
                @if (product.variants[variantIndex].inventory > 0) {
                  <p class="price mb-0 fw-bold">
                    {{product.variants[variantIndex].inventory < 6 ? 'Only ' + product.variants[variantIndex].inventory + ' Left' : 'In Stock'}}
                  </p>
                }
                @if (product.variants[variantIndex].inventory <= 0) {
                  <p class="price mb-0 fw-bold">Out of Stock</p>
                }
                <span class="price price-title">
                  ${{product.variants[variantIndex].price.toFixed(2)}}
                </span>
              }
            } @else {
              <ngx-skeleton-loader count="1"
                [theme]="{ width: '115px', height: '115px' }">
              </ngx-skeleton-loader>
            }
          </div>
        </div>
        <div class="mt-5 mb-3">
          <h3 class="mb-0">Size</h3>
          @if (product$ | async; as product) {
            @for (variant of product.variants; track variant; let i = $index) {
              <button
                class="mt-3"
                [ngClass]="i === variantIndex ? 'primary' : 'secondary'"
                [class.spacer]="product.variants.length > 1"
                (click)="selectVariant(product, i)">
                {{variant.variantTitle}}
              </button>
            }
          } @else {
            <div class="d-flex d-lg-none">
              <ngx-skeleton-loader count="1"
                [theme]="{ width: '100%', height: '36px' }">
              </ngx-skeleton-loader>
            </div>
            <div class="d-none d-lg-block">
              <ngx-skeleton-loader count="2"
                [theme]="{ width: '100%', height: '50px' }">
              </ngx-skeleton-loader>
            </div>
          }
        </div>
        @if (product$ | async; as product) {
          @if (product.variants[variantIndex]?.sellingPlanAllocations?.length) {
            <div class="my-5">
              <app-subscription
                (selectedSubscription)="selectedSubscriptionEvent($event)"
                [sellingAllocations]="product.variants[variantIndex].sellingPlanAllocations"
                [sellingPlans]="product.sellingPlanGroups[0].sellingPlans"
                [originalPrice]="product.variants[variantIndex].price"
              ></app-subscription>
            </div>
          }
        }
        <div class="row my-4">
          <div class="col-4 col-xl-3">
            @if (product$ | async; as product) {
              @if (product.variants[variantIndex].inventory > 0 && amountInCart < product.variants[variantIndex].inventory) {
                <button class="count-meter w-100">
                  <div class="d-flex justify-content-between align-items-center w-100">
                    <div class="d-flex align-items-center remove" (click)="remove()">
                      <mat-icon>remove</mat-icon>
                    </div>
                    <div>
                      <span>{{this.amountToAddToCart}}</span>
                    </div>
                    <div class="d-flex align-items-center add" (click)="add(product.variants[variantIndex])">
                      <mat-icon>add</mat-icon>
                    </div>
                  </div>
                </button>
              }
            } @else {
              <div class="d-flex d-lg-none">
                <ngx-skeleton-loader count="1"
                  [theme]="{ width: '100%', height: '36px' }">
                </ngx-skeleton-loader>
              </div>
              <div class="d-none d-lg-block">
                <ngx-skeleton-loader count="2"
                  [theme]="{ width: '100%', height: '50px' }">
                </ngx-skeleton-loader>
              </div>
            }
          </div>
          <div class="col-8 col-xl-9">
            @if (product$ | async; as product) {
              @if (product.variants[variantIndex].inventory > 0 && amountInCart < product.variants[variantIndex].inventory) {
                <button class="accent w-100" (click)="addProductToCart(product.variants[variantIndex])">
                  Add to Cart
                </button>
              } @else {
                <button class="accent w-100" disabled>
                  Out of Stock
                </button>
              }
            } @else {
              <div class="d-flex d-lg-none">
                <ngx-skeleton-loader count="1"
                  [theme]="{ width: '100%', height: '36px' }">
                </ngx-skeleton-loader>
              </div>
              <div class="d-none d-lg-block">
                <ngx-skeleton-loader count="2"
                  [theme]="{ width: '100%', height: '50px' }">
                </ngx-skeleton-loader>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- MOBILE -->
  <div class="d-flex d-lg-none flex-column justify-content-start align-items-evenly px-0 px-sm-3">
    <div class="product-title">
      @if (product$ | async; as product) {
        <h1 class="mb-0">{{product.title}}</h1>
      } @else {
        <div class="d-flex d-lg-none">
          <ngx-skeleton-loader count="1"
            [theme]="{ width: '100%', height: '36px' }">
          </ngx-skeleton-loader>
        </div>
        <div class="d-none d-lg-block">
          <ngx-skeleton-loader count="2"
            [theme]="{ width: '100%', height: '50px' }">
          </ngx-skeleton-loader>
        </div>
      }
    </div>
    <div class="d-flex justify-content-between align-items-center w-100">
      @if (product$ | async; as product) {
        @if (product.variants[variantIndex]) {
          <span class="price price-title">
            ${{product.variants[variantIndex].price.toFixed(2)}}
          </span>
          @if (product.variants[variantIndex].inventory > 0) {
            <h3 class="price mb-0 fw-bold">
              {{product.variants[variantIndex].inventory < 6 ? 'Only ' + product.variants[variantIndex].inventory + ' Left' : 'In Stock'}}
            </h3>
          }
          @if (product.variants[variantIndex].inventory <= 0) {
            <h3 class="price mb-0 fw-bold">Out of Stock</h3>
          }
        }
      } @else {
        <ngx-skeleton-loader count="1"
          [theme]="{ width: '115px', height: '50px' }">
        </ngx-skeleton-loader>
        <ngx-skeleton-loader count="1"
          [theme]="{ width: '115px', height: '50px' }">
        </ngx-skeleton-loader>
      }
    </div>
    <div class="d-flex justify-content-center w-100 my-3">
      @if ((product$ | async) === undefined) {
        <ngx-skeleton-loader count="1" [theme]="{ width: '350px', height: '350px' }">
        </ngx-skeleton-loader>
      }
      @if (product$ | async; as product) {
        <img class="product-image" [src]="product.variants[variantIndex].image.url" [alt]="product.variants[variantIndex].image.altText">
      }
    </div>
    <div class="text-center">
      <h3>Size</h3>
      <div class="d-flex justify-content-center flex-wrap">
        @if (product$ | async; as product) {
          @for (variant of product.variants; track variant; let i = $index) {
            <button
              class="size-btn mt-3"
              [ngClass]="i === variantIndex ? 'primary' : 'secondary'"
              [class.spacer]="product.variants.length > 1"
              (click)="selectVariant(product, i)">
              {{variant.variantTitle}}
            </button>
          }
        } @else {
          <div class="d-flex d-lg-none">
            <ngx-skeleton-loader count="1"
              [theme]="{ width: '100%', height: '36px' }">
            </ngx-skeleton-loader>
          </div>
          <div class="d-none d-lg-block">
            <ngx-skeleton-loader count="2"
              [theme]="{ width: '100%', height: '50px' }">
            </ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
    @if (product$ | async; as product) {
      @if (product.variants[variantIndex]?.sellingPlanAllocations?.length) {
        <div class="mt-5">
          <app-subscription
            (selectedSubscription)="selectedSubscriptionEvent($event)"
            [sellingAllocations]="product.variants[variantIndex].sellingPlanAllocations"
            [sellingPlans]="product.sellingPlanGroups[0].sellingPlans"
            [originalPrice]="product.variants[variantIndex].price"
          ></app-subscription>
        </div>
      }
    }
    <div class="d-flex justify-content-center mt-3 mb-5">
      <div class="me-3">
        @if (product$ | async; as product) {
          @if (product.variants[variantIndex].inventory > 0 && amountInCart < product.variants[variantIndex].inventory) {
            <button class="count-meter w-100">
              <div class="d-flex justify-content-between align-items-center w-100">
                <div class="d-flex align-items-center remove" (click)="remove()">
                  <mat-icon>remove</mat-icon>
                </div>
                <div>
                  <span>{{this.amountToAddToCart}}</span>
                </div>
                <div class="d-flex align-items-center add" (click)="add(product.variants[variantIndex])">
                  <mat-icon>add</mat-icon>
                </div>
              </div>
            </button>
          }
        } @else {
          <div class="d-flex d-lg-none">
            <ngx-skeleton-loader count="1"
              [theme]="{ width: '100%', height: '36px' }">
            </ngx-skeleton-loader>
          </div>
          <div class="d-none d-lg-block">
            <ngx-skeleton-loader count="2"
              [theme]="{ width: '100%', height: '50px' }">
            </ngx-skeleton-loader>
          </div>
        }
      </div>
      @if (product$ | async; as product) {
        @if (product.variants[variantIndex].inventory > 0 && amountInCart < product.variants[variantIndex].inventory) {
          <button class="accent" (click)="addProductToCart(product.variants[variantIndex])">
            Add to Cart
          </button>
        } @else {
          <button class="accent" disabled>
            Out of Stock
          </button>
        }
      } @else {
        <div class="d-flex d-lg-none">
          <ngx-skeleton-loader count="1"
            [theme]="{ width: '100%', height: '36px' }">
          </ngx-skeleton-loader>
        </div>
        <div class="d-none d-lg-block">
          <ngx-skeleton-loader count="2"
            [theme]="{ width: '100%', height: '50px' }">
          </ngx-skeleton-loader>
        </div>
      }
    </div>
    <div class="text-left">
      @if (product$ | async; as product) {
        <div class="mt-3">
          <h3>Description</h3>
          <span [innerHtml]="product.descriptionHtml"></span>
        </div>
      }
    </div>
  </div>
  <!-- Both -->
  @if (product$ | async; as product;) {
    <div class="my-5">
      <app-similar-products [productId]="product.id"></app-similar-products>
    </div>
  }
</div>
